import UAparser from 'ua-parser-js';
import { useDeviceCheck } from '@/composables/useDeviceCheck';

export default defineNuxtPlugin((nuxtApp): void => {
  const { isLargeScreen, setLargeScreenState } = useDeviceCheck();

  const setDeviceType = (userAgent: string): void => {
    const parser = new UAparser(userAgent);
    const device = parser.getDevice();
    setLargeScreenState(device.type === undefined || !['wearable', 'mobile'].includes(device.type));
  };

  if (isLargeScreen.value === null) {
    if (!import.meta.client) {
      const headers = useRequestHeaders();
      const serverUserAgent = headers['user-agent'];
      setDeviceType(serverUserAgent);
    } else {
      const clientUserAgent = window.navigator.userAgent;
      setDeviceType(clientUserAgent);
    }
  }

  const checkWindowSize = (): void => {
    setLargeScreenState(window.innerWidth >= 768);
  };

  if (import.meta.client) {
    window.removeEventListener('resize', checkWindowSize);
    nuxtApp.hook('page:finish', () => {
      window.addEventListener('resize', checkWindowSize);
      checkWindowSize();
    });
  }
});
